import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { TopBar } from "../components/TopBar";
import { api, formatDate } from "../lib/api";
import { History } from "lucide-react";

export default function AuditPage() {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/audit-log")
      .then((r) => setLogs(r.data))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="min-h-screen bg-zinc-50">
      <TopBar />
      <main className="mx-auto max-w-[1300px] px-4 sm:px-6 py-6">
        <h1 className="font-heading text-3xl sm:text-4xl font-extrabold tracking-tighter text-zinc-950 mb-1">
          Audit Log
        </h1>
        <p className="text-sm text-zinc-600 mb-6">
          Every change, every user, every source. The full operational trail.
        </p>

        <div className="bg-white border border-zinc-200 rounded-md shadow-sm overflow-hidden">
          <table className="w-full text-sm">
            <thead className="bg-zinc-50">
              <tr className="text-[10px] uppercase tracking-wider text-zinc-500">
                <th className="text-left py-3 px-4 font-semibold">When</th>
                <th className="text-left py-3 px-4 font-semibold">User</th>
                <th className="text-left py-3 px-4 font-semibold">Action</th>
                <th className="text-left py-3 px-4 font-semibold">Field</th>
                <th className="text-left py-3 px-4 font-semibold">Change</th>
                <th className="text-left py-3 px-4 font-semibold">Source</th>
                <th className="text-left py-3 px-4 font-semibold">Record</th>
              </tr>
            </thead>
            <tbody>
              {loading && <tr><td colSpan={7} className="p-8 text-center text-zinc-400">Loading…</td></tr>}
              {!loading && logs.length === 0 && (
                <tr><td colSpan={7} className="p-8 text-center text-zinc-400">No audit entries yet.</td></tr>
              )}
              {logs.map((l) => (
                <tr key={l.id} className="border-t border-zinc-100 hover:bg-zinc-50">
                  <td className="py-2.5 px-4 text-xs text-zinc-500 whitespace-nowrap">{formatDate(l.timestamp)}</td>
                  <td className="py-2.5 px-4 text-xs">
                    <div className="font-semibold text-zinc-900">{l.user_name}</div>
                    <div className="text-zinc-500">{l.company}</div>
                  </td>
                  <td className="py-2.5 px-4 text-xs">
                    <span className="font-mono px-1.5 py-0.5 rounded bg-zinc-100 text-zinc-700">{l.action}</span>
                  </td>
                  <td className="py-2.5 px-4 text-xs font-mono text-zinc-700">{l.field}</td>
                  <td className="py-2.5 px-4 text-xs text-zinc-700">
                    {l.previous_value !== null && l.new_value !== null ? (
                      <>
                        <span className="line-through text-zinc-400">{l.previous_value || "—"}</span>
                        {" → "}
                        <span className="font-medium">{l.new_value}</span>
                      </>
                    ) : l.new_value || "—"}
                  </td>
                  <td className="py-2.5 px-4 text-xs text-zinc-500">{l.source.replace("_", " ")}</td>
                  <td className="py-2.5 px-4 text-xs">
                    <Link to={`/bath/${l.bath_record_id}`} className="text-zinc-950 hover:underline font-mono" data-testid={`audit-link-${l.id}`}>
                      Open ›
                    </Link>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </main>
    </div>
  );
}
